import { IGamificationAuditEvent } from "@/@types/gamification-audit";

const ACTION_LABELS: Record<string, string> = {
  CREATE: "Criação",
  UPDATE: "Edição",
  DELETE: "Inativação",
  PATCH: "Edição",
};

const ACTION_COLORS: Record<string, string> = {
  CREATE: "text-green-700 bg-green-50",
  UPDATE: "text-blue-700 bg-blue-50",
  DELETE: "text-red-700 bg-red-50",
  PATCH: "text-blue-700 bg-blue-50",
};

export const getActionLabel = (action: string): string =>
  ACTION_LABELS[action] ?? "Ação";

export const getActionColor = (action: string): string =>
  ACTION_COLORS[action] ?? "text-gray-700 bg-gray-50";

export const getEventDescription = (event: IGamificationAuditEvent): string => {
  const message = event.event_payload?.message;
  if (message) return message;

  const info = event.information?.replace(/^\[[A-Z0-9_]+\]\s*/, "").trim();
  if (info) return info;

  return getActionLabel(event.action);
};

export const getUpdatedFields = (event: IGamificationAuditEvent): string[] => {
  const fields = event.event_payload?.fieldsUpdated;
  return Array.isArray(fields) ? fields : [];
};
